// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, object, oneOfType, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getOptions } from './helpers'
import { UpdatedInputWithUnitToggleWrapper } from './styles'
import UpdatedInputBase from '../UpdatedInputBase'

import {
  ErrorSimple,
  LabelSimple,
  LookupWrapper,
  UpdatedRadioGroup,
} from 'components/Form'

import {
  change,
  Field,
} from 'redux-form'

import {
  castToString,
  getNestedByString,
} from 'helpers/reduxFormFunctions'

import {
  convertBetweenKMandMI,
  convertBetweenMandFt,
} from 'helpers/unitConversion'

// NOTE - if you pass "lookup" as an empty string, it will adjust the grid to account for the space the lookup would occupy.
// This creates an easy convention for this css grid to handle multiple scenarios.

class UpdatedInputWithUnitToggle extends UpdatedInputBase {
  static propTypes = {
    autoFocus: bool,
    className: string,
    disabled: bool,
    formatOnDisabled: bool,
    id: string.isRequired,
    input: object.isRequired,
    label: oneOfType([
      string,
      object,
    ]),
    lookup: oneOfType([
      string,
      object,
    ]),
    meta: object.isRequired,
    onBlur: func,
    onChange: func,
    onFocus: func,
    placeholder: string,
    readOnly: bool,
    type: string,
  }

  static defaultProps = {
    className: '',
    lookup: null,
  }

  state = {
    options: [],
  }

  componentDidMount () {
    // makes it so that the options will either be
    // m <> ft
    // or
    // km <> mi
    const options = getOptions(this.props.convertDistance)
    this.setState(() => ({ options }))
  }

  toggleInputUnit = (e, c) => {
    // allow the unit radio's change event to be passed to redux-form
    c(e)

    // convert input's value to new unit and dispatch change here.
    const {
      convertDistance,
      input,
      inputValue,
    } = this.props

    const newUnit = e.target.value
    const n = (
      convertDistance
        ? convertBetweenKMandMI(inputValue, newUnit)
        : convertBetweenMandFt(inputValue, newUnit)
    )
    const newInputValue = castToString(n)
    input.onChange(newInputValue)
  }

  render () {
    const {
      autoFocus,
      className,
      disabled,
      id,
      input,
      label,
      lookup,
      meta: { error },
      placeholder,
      readOnly,
      type,
    } = this.props

    return (
      <UpdatedInputWithUnitToggleWrapper className={`updated-input-with-unit-toggle ${className}`}>
        <LabelSimple
          idRoot={id}
          label={label} />
        <input
          {...input}
          autoFocus={autoFocus}
          className={'input'}
          disabled={disabled}
          id={id}
          placeholder={placeholder}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          readOnly={readOnly}
          type={type} />
        <Field
          className={'unit-toggle'}
          component={UpdatedRadioGroup}
          disabled={disabled}
          idRoot={`${id}Unit`}
          name={`${input.name}Unit`}
          onChangeCustom={this.toggleInputUnit}
          options={this.state.options} />
        <LookupWrapper
          lookup={lookup} />
        <ErrorSimple
          error={error}
          idRoot={id} />
      </UpdatedInputWithUnitToggleWrapper>
    )
  }
}

const mapStateToProps = ({ form }, { input, sourceForm }) => {
  const { values } = form[sourceForm]
  // defaulting to empty string because of redux-form bug:
  // https://github.com/erikras/redux-form/issues/3366
  const inputValue = getNestedByString(values, input.name) || ''
  const selectedUnit = getNestedByString(values, `${input.name}Unit`)

  return {
    inputValue,
    selectedUnit,
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    change,
  }, dispatch)
)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdatedInputWithUnitToggle)
